export default "__VITE_ASSET__BfyDPVTH__"